import ncmList from "@static/ncm.json";

// Descrição da tabela NCM por código (a mesma lista do formulário de NCM).
let ncmDescricoes: Map<string, string> | null = null;

/** Descrição oficial do NCM (tabela do app), sem o código na frente. */
export function descricaoNcm(codigo: string | undefined | null): string {
  const digitos = (codigo ?? "").toString().replace(/\D/g, "");
  if (!digitos) return "";

  if (!ncmDescricoes) {
    ncmDescricoes = new Map(
      (ncmList as { display: string; value: string }[]).map((item) => [
        item.value,
        item.display.replace(/^[\d.]+\s*-\s*/, "")
      ])
    );
  }

  return ncmDescricoes.get(digitos) ?? "";
}
